import { Form } from 'antd';
import styles from './searchGroup.less?modules';
import SingInputML from '@/components/input_all_ml/form_sing_input_ml/SingInputML';
import ButtonML from '@/components/button_ml/ButtonML';
import { useSelector } from 'dva';
// import DropDown from '@/components/dropdown/Dropdown';
// import { Menu, message } from 'antd';
// import Update from '@/containers/update_ml/Update';
// import { useDispatch } from 'dva';
import { history } from 'umi';

const SearchGroup = (props) => {
  const [form] = Form.useForm();
  // const dispatch = useDispatch();

  const { addRuleChange, handleDelete } = props || {};
  const Tabledata = useSelector(
    (state) => state.ruleManageDetail.getRuleDetailList,
  );
  let editable = true;
  if (Tabledata && Tabledata[0]) {
    editable = Tabledata[0].editable;
  }

  const onFinish = (values) => {
    for (let key in values) {
      if (!values[key]) {
        values[key] = undefined;
      }
    }
    props.handleSearch(values);
  };

  const onReset = () => {
    form.resetFields();
    // props.handleSearch({});
  };
  const addRule = () => {
    addRuleChange && addRuleChange();
  };

  // const actionSingle = (e) => {
  //   const formData = new FormData();
  //   formData.append('uploadFile', e);
  //   dispatch({
  //     type: 'ruleManageDetail/importSingle',
  //     payload: {
  //       values: formData,
  //       id: id,
  //     },
  //     callback: (d) => {
  //       const { code, message: s } = d || {};
  //       if (code && code !== 0) {
  //         message.warning(s);
  //         return;
  //       }
  //       message.success('导入成功');
  //     },
  //   });
  // };
  // const actionMultiple = (e) => {
  //   const formData = new FormData();
  //   formData.append('uploadFile', e);
  //   dispatch({
  //     type: 'ruleManageDetail/importMultiple',
  //     payload: {
  //       values: formData,
  //       id: id,
  //     },
  //     callback: (d) => {
  //       const { code, message: s } = d || {};
  //       if (code && code !== 0) {
  //         message.warning(s);
  //         return;
  //       }
  //       message.success('导入成功');
  //     },
  //   });
  // };
  //下拉的menu
  // const menu = (
  //   <Menu>
  //     <Menu.Item>
  //       <Update text="单条件导入" action={actionSingle} accept=".json" />
  //     </Menu.Item>
  //     <Menu.Item>
  //       <Update text="多条件导入" action={actionMultiple} accept=".json" />
  //     </Menu.Item>
  //   </Menu>
  // );
  return (
    <Form
      form={form}
      name="control-hooks"
      onFinish={onFinish}
      className={styles.serarchFrom}
    >
      {/* 会员号 */}
      {/* <Col span={8}> */}
      <div className={styles.input_contain}>
        <SingInputML
          height="37px"
          labelwidth="130px"
          inputWidth="269px"
          labelVal="规则名称"
          placeVal="请输入规则名称"
          name="ruleName"
          allowClear={true}
          // icon={}
        />
      </div>

      <div className={styles.btn_contain}>
        <ButtonML
          size="large"
          value="查询"
          htmlType="submit"
          // width="106px"
          // height="46px"
          fontsize="16px"
        />
        <ButtonML
          size="large"
          value="重置"
          // width="106px"
          // height="46px"
          fontsize="16px"
          onClick={onReset}
        />
        <ButtonML
          size="large"
          value="新增"
          // width="106px"
          // height="46px"
          fontsize="16px"
          onClick={addRule}
          disabled={String(editable) === 'false'}
        />
        <ButtonML
          size="large"
          value="批量删除"
          // width="106px"
          // height="46px"
          fontsize="16px"
          onClick={() => handleDelete()}
          disabled={String(editable) === 'false'}
        />
        {/* <DropDown
          menu={menu}
          btnVal="其他操作"
          disabled={String(editable) === 'false'}
        /> */}
        <ButtonML
          size="large"
          value="返回"
          // width="106px"
          // height="46px"
          fontsize="16px"
          onClick={() => history.go(-1)}
        />
      </div>
    </Form>
  );
};

export default SearchGroup;
